import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-list-item-detail',
  templateUrl: './list-item-detail.component.html',
  styleUrls: ['./list-item-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListItemDetailComponent implements OnInit {

  @Input() title: string;

  constructor() { }

  ngOnInit() {
  }

}
